import { render } from "./Cryptocurrencies.vue?vue&type=template&id=e2859ca2&scoped=true&ts=true"
import script from "./Cryptocurrencies.vue?vue&type=script&lang=ts"
export * from "./Cryptocurrencies.vue?vue&type=script&lang=ts"

import "./Cryptocurrencies.vue?vue&type=style&index=0&id=e2859ca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2859ca2"]])

export default __exports__